import React, { useState } from 'react';
import HocPhanBoSung from '../hocPhanBoSung/HocPhanBoSung';
import HocPhanTienSi from './HocPhanTienSi';
import ChuyenDeTienSi from '../chuyenDeTienSi/ChuyenDeTienSi';
import TieuLuanTongQuan from '../tieuLuanTongQuan/TieuLuanTongQuan';
import DuyetHocPhanBoSung from '../hocPhanBoSung/DuyetHocPhanBoSung';
import DuyetHocPhanTienSi from './DuyetHocPhanTienSi';
import DuyetChuyenDeTienSi from '../chuyenDeTienSi/DuyetChuyenDeTienSi';
import DuyetTieuLuanTongQuan from '../tieuLuanTongQuan/DuyetTieuLuanTongQuan';

const HocPhanTienSiTab = ({ hoSoId, isAdmin }) => {
    const [activeTab, setActiveTab] = useState('hocPhanBoSung');

    if (activeTab === 'hocPhanBoSung') {
        if (isAdmin) {
            return <DuyetHocPhanBoSung hoSoId={hoSoId} activeTab={activeTab} setActiveTab={setActiveTab} />;
        }
        return <HocPhanBoSung hoSoId={hoSoId} activeTab={activeTab} setActiveTab={setActiveTab} />;
    }
    
    if (activeTab === 'hocPhanTienSi') {
        if (isAdmin) {
            return <DuyetHocPhanTienSi hoSoId={hoSoId} activeTab={activeTab} setActiveTab={setActiveTab} />;
        }
        return <HocPhanTienSi hoSoId={hoSoId} activeTab={activeTab} setActiveTab={setActiveTab} />;
    }

    if (activeTab === 'chuyenDeTienSi') {
        if (isAdmin) {
            return <DuyetChuyenDeTienSi hoSoId={hoSoId} activeTab={activeTab} setActiveTab={setActiveTab} />;
        }
        return <ChuyenDeTienSi hoSoId={hoSoId} activeTab={activeTab} setActiveTab={setActiveTab} />;
    }

    if (activeTab === 'tieuLuanTongQuan') {
        if (isAdmin) {
            return <DuyetTieuLuanTongQuan hoSoId={hoSoId} activeTab={activeTab} setActiveTab={setActiveTab} />;
        }
        return <TieuLuanTongQuan hoSoId={hoSoId} activeTab={activeTab} setActiveTab={setActiveTab} />;
    }

    return null;
};

export default HocPhanTienSiTab;
